export default __webpack_public_path__ + "static/media/ls3_g01.29bb81c7.png";